/**
 * Product card image carousel on hover (WAMA / enhanced collections).
 */
function initEspaceCardCarousels(root) {
  const scope = root || document;
  const carousels = scope.querySelectorAll('[data-espace-card-carousel]:not([data-carousel-init])');

  carousels.forEach((carousel) => {
    carousel.setAttribute('data-carousel-init', 'true');
    const slides = carousel.querySelectorAll('.espace-card-carousel__slide');
    if (slides.length < 2) return;

    const intervalMs = parseInt(carousel.dataset.interval, 10) || 700;
    const dotsWrap = carousel.querySelector('.espace-card-carousel__dots');
    let index = 0;
    let timer = null;

    if (dotsWrap && !dotsWrap.children.length) {
      slides.forEach((_, i) => {
        const dot = document.createElement('span');
        dot.className = 'espace-card-carousel__dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(dot);
      });
    }

    const dots = dotsWrap ? dotsWrap.querySelectorAll('.espace-card-carousel__dot') : [];

    function showSlide(next) {
      slides[index].classList.remove('is-active');
      if (dots[index]) dots[index].classList.remove('is-active');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
    }

    function start() {
      stop();
      timer = window.setInterval(() => showSlide(index + 1), intervalMs);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
      if (index !== 0) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = 0;
        slides[0].classList.add('is-active');
        if (dots[0]) dots[0].classList.add('is-active');
      }
    }

    const card = carousel.closest('.card-wrapper') || carousel;
    card.addEventListener('mouseenter', start);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusin', start);
    card.addEventListener('focusout', (e) => {
      if (!card.contains(e.relatedTarget)) stop();
    });
  });
}

function onEspaceCollectionUpdate() {
  initEspaceCardCarousels(document.getElementById('ProductGridContainer') || document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initEspaceCardCarousels(document));
} else {
  initEspaceCardCarousels(document);
}

document.addEventListener('shopify:section:load', (e) => initEspaceCardCarousels(e.target));
document.addEventListener('facets:updated', onEspaceCollectionUpdate);
